import { render, staticRenderFns } from "./MoveBeforeFieldModal.vue?vue&type=template&id=10252dcb&"
import script from "./MoveBeforeFieldModal.vue?vue&type=script&lang=js&"
export * from "./MoveBeforeFieldModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveBeforeFieldModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports